/* v8 ignore start */
//older browsers don't support full Set functionality
if (!Set.prototype.symmetricDifference) {
  //eslint-disable-next-line no-extend-native
  Set.prototype.symmetricDifference = function <T, U>(
    this: Set<T>,
    other: ReadonlySetLike<U>
  ): Set<T | U> {
    const result = new Set<T | U>();

    // Add elements from this set that are not in other
    for (const element of this) {
      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (!other.has(element as any)) {
        result.add(element);
      }
    }

    // Add elements from other set that are not in this
    //@ts-expect-error this works
    for (const element of other) {
      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (!this.has(element as any)) {
        result.add(element);
      }
    }

    return result;
  };
}
/* v8 ignore stop */
